import { Components, Theme } from '@mui/material';

const MuiDialogContent: Components<Theme>['MuiDialogContent'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(
        0,
        theme.spacingSizes.lg,
        0,
        theme.spacingSizes.lg,
      ),
    }),
  },
};

export default MuiDialogContent;
